import React from 'react';
import { styled } from '@mui/material/styles';
import MuiChip from '@mui/material/Chip';
import { updateColorLight } from 'utils/colorHelpers';

export const Chip = styled(React.forwardRef(({ isFocused, ...rest }, ref) => (
  <MuiChip ref={ref} {...rest} />
)))(({ theme, isFocused }) => ({
  backgroundColor: updateColorLight(
    theme.color.primary.main,
    isFocused ? 90 : 85
  ),
  margin: `${theme.spacing(0.25)} ${theme.spacing(0.5)} ${theme.spacing(0.25)} 0`
}));
